import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';

@Component({
  selector: 'vex-on-demand-category',
  templateUrl: './on-demand-category.component.html',
  styleUrls: ['./on-demand-category.component.scss']
})
export class OnDemandCategoryComponent implements OnInit {
  category: any;

  constructor(public guiService: GuiService, public translate: TranslateService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if(sessionStorage.getItem('selectedOndemandCategory')){
      this.category = JSON.parse(sessionStorage.getItem('selectedOndemandCategory'));
      console.debug('selected category', this.category)
    }else{
      this.guiService.goTo('main/on-demand/live_video')
    }
  }

  openVideo(video){
    const item = JSON.stringify(video);
    sessionStorage.setItem('selectedOndemandVideo', item);
    this.guiService.goTo('main/ondemand-video');
  }

}

